/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryExtraKey extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryExtraKey");
    }

    getFixupPrototypeFunction() { return ResourceQueryExtraKey.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryExtraKey>): ResourceQueryExtraKey {
        let obj = Object.assign(new ResourceQueryExtraKey(), model);
        ResourceQueryExtraKey.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryExtraKey>): ResourceQueryExtraKey {
        if (!model) return null;
        return ResourceQueryExtraKey.newInstance(<ResourceQueryExtraKey> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryExtraKey) {
        if (!obj) return;

        models.ResourceQueryExtraKey.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryExtraKey): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryExtraKey.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Extra keys for the resources
     */
    extra_keys: Array<string>;

}
